import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MAT_MENU_DEFAULT_OPTIONS } from '@angular/material/menu';
import { ViewStateRecord } from '@common/data-models/records/viewstate-record';
import { ViewStateTypes } from '@common/enums/viewstate-types';
import { LanguageSettings } from '@common/services/language-settings';
import { LayoutState } from '@common/services/layout-state';
import { NavigationService } from '@common/services/navigation-service';
import { NavigationGroup, NavigationItem, NavigationSection } from '@common/store/navigation/models/navigation.models';
import { FilterTypes } from '@src/suite/common/enums/filter-types';
import { GlobalTablesService } from '@src/suite/common/services/global-tables-service';
import { CreateViewStateActions } from '@src/suite/common/store/createviewstate/createviewstate.actions';
import {
    selectCreateViewStateLayoutOptions,
    selectCreateViewStateLockMapLocation,
    selectCreateViewStateMapShowTeamLocations,
    selectCreateViewStateMapZoomToCoverage,
} from '@src/suite/common/store/createviewstate/createviewstate.selectors';

import { BaseViewState } from './base-view-state';

@Component({
    selector: 'st-live-view-state',
    templateUrl: './live-view-state.html',
    styleUrls: ['./live-view-state.scss'],
    providers: [
        {
            provide: MAT_MENU_DEFAULT_OPTIONS,
            useValue: { overlayPanelClass: 'st-live-view-state-menu' },
        },
    ],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-live-view-state',
    },
})
export class LiveViewStateComponent extends BaseViewState {
    public filterTypes = FilterTypes;

    viewStateLockMapLocation$ = this.store.select(selectCreateViewStateLockMapLocation);
    viewStateMapShowTeamLocations$ = this.store.select(selectCreateViewStateMapShowTeamLocations);
    viewStateMapZoomToCoverage$ = this.store.select(selectCreateViewStateMapZoomToCoverage);
    viewStateLayout$ = this.store.select(selectCreateViewStateLayoutOptions);

    constructor(
        public languageSettings: LanguageSettings,
        public viewStateService: LayoutState,
        public navigationService: NavigationService,
        public dialogRef: MatDialogRef<LiveViewStateComponent>,
        public globalTablesService: GlobalTablesService,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            copy: boolean;
            edit: boolean;
            vs: ViewStateRecord;
            group: NavigationGroup;
            section: NavigationSection;
            item: NavigationItem;
        }
    ) {
        super();
        this.store.dispatch(
            CreateViewStateActions.initializeViewState({
                vstype: ViewStateTypes.ROLIST,
                copy: data.copy,
                edit: data.edit,
                vs: data.vs,
                group: data.group,
                section: data.section,
                item: data.item,
            })
        );
    }

    updateLockMapLocation(locked: boolean) {
        this.store.dispatch(CreateViewStateActions.updateViewStateLockMapLocation({ locked: locked }));
    }

    updateMapShowTeamLocations(show: boolean) {
        this.store.dispatch(CreateViewStateActions.updateViewStateMapShowTeamLocations({ show: show }));
    }

    updateMapZoomToCoverage(zoom: boolean) {
        this.store.dispatch(CreateViewStateActions.updateViewStateMapZoomToCoverage({ zoom: zoom }));
    }

    updateSlideshowDelay(delay: number) {
        this.store.dispatch(CreateViewStateActions.updateViewStateSlideshowDelay({ delay: delay }));
    }

    updateSlideshowSequence(guid: string, checked: boolean) {
        this.store.dispatch(CreateViewStateActions.updateViewStateSlideshowSequence({ guid: guid, checked: checked }));
    }
}
